import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { CustomNavParams } from '../../providers/custom-nav-params/custom-nav-params';

@Component({
    templateUrl: 'past-homekeeper.html',
    selector: 'past-homekeeper',
    styleUrls: ['./past-homekeeper.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PastHomekeeper {

  @Input() noPlan;
  @Input() pastHk;
  @Input() blackList;
  @Input() showPastHk;

  constructor(
    private navCtrl: CustomNavController,
    private customNavParams: CustomNavParams
  ) {}

  goToPastHomekeeperPage(hk) {
    this.customNavParams.setParams(
      `HomekeeperPage`,  {
        hk,
        'noPlan': this.noPlan,
        'blacklist': false,
      }
    );
    this.navCtrl.navigateForward(['homekeeper']);
  }
}
